"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveIbanRequestPayloadToJSON = exports.SaveIbanRequestPayloadFromJSONTyped = exports.SaveIbanRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
function SaveIbanRequestPayloadFromJSON(json) {
    return SaveIbanRequestPayloadFromJSONTyped(json, false);
}
exports.SaveIbanRequestPayloadFromJSON = SaveIbanRequestPayloadFromJSON;
function SaveIbanRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'iban': json['iban'],
        'customerNo': !(0, runtime_1.exists)(json, 'customerNo') ? undefined : json['customerNo'],
    };
}
exports.SaveIbanRequestPayloadFromJSONTyped = SaveIbanRequestPayloadFromJSONTyped;
function SaveIbanRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'iban': value.iban,
        'customerNo': value.customerNo,
    };
}
exports.SaveIbanRequestPayloadToJSON = SaveIbanRequestPayloadToJSON;
//# sourceMappingURL=SaveIbanRequestPayload.js.map